import { Skeleton } from '@mercai/clever'
import { useEffect, useRef, useState } from 'react'

import { useTransportCompanyList } from '@/services'

import { DropDownSearch, InputSearch } from './components'

import type { TransportCompanyProps } from '@/types'

import type { TransportCompanySearchProps } from './transport-company-search.type'

import styles from './transport-company-search.module.css'

export const TransportCompanySearch = ({
  onSelect,
  selected,
  error,
  maxHeightDropdown,
  title,
}: TransportCompanySearchProps) => {
  const [value, setValue] = useState('')
  const [isOpen, setIsOpen] = useState(false)

  const { data, isLoading } = useTransportCompanyList({
    params: { search: value },
  })

  const onChangeValue = (newValue: string) => {
    setValue(newValue)

    if (selected?.uuid) {
      onSelect({})
    }
  }

  const onHandleSelect = (valueParam: TransportCompanyProps) => {
    setIsOpen(false)
    onSelect(valueParam)
  }

  useEffect(() => {
    if (selected?.name) {
      setValue(selected?.name)
    }

    return () => {
      setValue('')
    }
  }, [selected])

  const rootRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const closeOpennedDropDown = (e: MouseEvent) => {
      if (
        rootRef.current &&
        isOpen &&
        !rootRef.current.contains(e.target as Node)
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', closeOpennedDropDown)

    return () => document.removeEventListener('mousedown', closeOpennedDropDown)
  }, [isOpen, rootRef])

  return (
    <div className={styles.core} ref={rootRef}>
      {isLoading && !isOpen ? (
        <div className={styles['wrap-skeleton']}>
          <Skeleton width="70%" height="1.25rem" />
          <Skeleton width="100%" height="2.5rem" />
        </div>
      ) : (
        <InputSearch
          onChange={onChangeValue}
          value={value}
          onOpen={setIsOpen}
          error={error}
          title={title}
        />
      )}

      <DropDownSearch
        isOpen={isOpen}
        data={data?.data?.results}
        isLoading={isLoading}
        onSelect={onHandleSelect}
        selected={selected}
        maxHeight={maxHeightDropdown}
      />
    </div>
  )
}
